import { getPopupContainer, IItem } from '@bimser/core';
import { GetIconComponent } from '@bimser/icons';
import IconEmpty from '@bimser/icons/16/empty-icon';
import IconMenupopArrow from '@bimser/icons/16/menupop-arrow';
import { Button, Dropdown } from 'antd';
import classNames from 'classnames/bind';
import * as React from 'react';
import { findMessage } from '../BCIntl';
import BCMenu from '../BCMenu';
import { BCPortalStyleExtractor } from '../BCPortalStyleExtractor';
import Style from './assets/style.scss';
import { IDropdownProps, IDropdownSelectedChangedEventArgs } from './entities';
import IDropdownOptionArgs from './entities/IDropdownOptionArgs';

const cx = classNames.bind(Style);
const dropDownButtonStyle: React.CSSProperties = { marginLeft: 3, marginTop: 1 };

const BCDropdown = ({ items = [], ...props }: IDropdownProps) => {
	Style;

	const defaultItem = items.find(i => i.value === props.defaultValue);
	const selectedItem = items.find(i => i.selected);

	const selectedChanged = args => {
		props.onSelected?.({ domEvent: args.domEvent, data: args.data });
	};

	const getOptions = () => {
		const options: Array<IItem> = [...items];

		if (!props.isHiddenDefaultItem) {
			options.unshift({
				key: 'dropdownChoose',
				text: props.placeholder || findMessage.get('100637'),
				value: null,
				icon: items.find(i => !!i.icon) ? IconEmpty.info : undefined
			});
		}

		return BCMenu({
			items: options,
			mode: 'vertical',
			className: props.optionClassName,
			style: props.optionStyle,
			onClick: selectedChanged,
			getOnlyMenuProps: true,
			selectedKeys: selectedItem?.key || []
		});
	};

	const renderSelectedItemInner = () => {
		const { value, icon, text } = selectedItem || defaultItem || {};
		const iconComponent = GetIconComponent(icon || props.defaultIcon);
		const defaultText = props.placeholder || findMessage.get('100637');
		const valueText = value ? text : defaultText;

		switch (props.selectedItemShowType) {
			case 'icon':
				return value ? iconComponent : <span title={defaultText}>{defaultText}</span>;
			case 'icontext':
				return (
					<span className={Style.iconWithText}>
						{iconComponent}
						<span title={valueText}>{valueText}</span>
					</span>
				);
			default:
				return <span title={valueText}>{valueText}</span>;
		}
	};

	const renderSelectedItem = () => (
		<Button
			tabIndex={props.tabIndex}
			key={(selectedItem || defaultItem)?.value}
			style={{ textAlign: 'left', ...props.style }}
			loading={props.loading ? { delay: 100 } : false}
			type={props.buttonType}
			ghost={props.ghost}
			size={props.size}
			disabled={props.disabled || props.readonly}
			className={cx({ readonlyCursor: props.readonly })}
		>
			{renderSelectedItemInner()}
			<IconMenupopArrow
				style={dropDownButtonStyle}
				height="30px"
				width="8px"
				className="tableheader-sort-arrow"
			/>
		</Button>
	);

	const renderPicker = () => (
		<Dropdown
			menu={getOptions()}
			disabled={props.disabled || props.readonly}
			className={props.className}
			trigger={['click']}
			getPopupContainer={props.getPopupContainer || getPopupContainer}
			overlayClassName={[Style.dropdownStyle, props.overlayClassName].join(' ')}
		>
			{renderSelectedItem()}
		</Dropdown>
	);

	if (props.extractPopupKey) {
		return (
			<BCPortalStyleExtractor extractPopupKey={props.extractPopupKey}>
				{renderPicker()}
			</BCPortalStyleExtractor>
		);
	}

	return renderPicker();
};

export default BCDropdown;
export {
	Dropdown as AntdDropdown,
	IDropdownOptionArgs,
	IDropdownProps,
	IDropdownSelectedChangedEventArgs
};
